import React from "react"
import "./email.scss"

const Email = () => {
  return (
    <div className="email">
      <a href="mailto:durgeshkumar384@gmail.com">durgeshkumar384@gmail.com</a>
    </div>
  )
}

export default Email
